import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { I18nProvider } from "@/i18n/I18nProvider";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import StatsBar from "@/components/StatsBar";
import Services from "@/components/Services";
import Pricing from "@/components/Pricing";
import HowItWorks from "@/components/HowItWorks";
import WhyUs from "@/components/WhyUs";
import Areas from "@/components/Areas";
import Testimonials from "@/components/Testimonials";
import BookingForm from "@/components/BookingForm";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";

const Landing = () => (
  <main data-testid="landing-page" className="relative bg-black text-white overflow-x-hidden">
    <Navbar />
    <Hero />
    <StatsBar />
    <Services />
    <Pricing />
    <HowItWorks />
    <WhyUs />
    <Areas />
    <Testimonials />
    <BookingForm />
    <FAQ />
    <Footer />
    <FloatingActions />
    <Toaster
      position="bottom-center"
      theme="dark"
      toastOptions={{
        style: {
          background: "#0A0A0A",
          color: "#fff",
          border: "1px solid rgba(236,0,140,0.3)",
        },
      }}
    />
  </main>
);

function App() {
  return (
    <I18nProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
          </Routes>
        </BrowserRouter>
      </div>
    </I18nProvider>
  );
}

export default App;
